import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
    name: 'themes',
    initialState: {
        themeList: [],
        selectedTheme: '',
    },
    reducers: {
        setThemes: (state, action) => {
            state.themeList = action.payload;
        },
        selectTheme: (state, action) => {
            state.selectedTheme = action.payload;
        },
    },
});

export const { setThemes, selectTheme } = themeSlice.actions;

export const selectThemeList = (state) => state.themes.themeList;
export const selectCurrentTheme = (state) => state.themes.selectedTheme;

export default themeSlice.reducer;